module.exports = __webpack_public_path__ + "img/security.821983c1.svg";